import React, { useState, useRef, useEffect } from "react";
import "./App.css";
import { BrowserView, MobileView } from "react-device-detect";
import Player from "@madzadev/audio-player";
import "@madzadev/audio-player/dist/index.css";

// Componente con controles básicos de audio extra
function ExtraAudioPlayer({ title, url, cover }) {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const togglePlay = () => {
    const audio = audioRef.current;
    if (!audio) return;

    if (isPlaying) {
      audio.pause();
    } else {
      audio.play();
    }
    setIsPlaying(!isPlaying);
  };

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;
    const onEnded = () => setIsPlaying(false);
    audio.addEventListener("ended", onEnded);
    return () => audio.removeEventListener("ended", onEnded);
  }, []);

  return (
    <div className="extra-audio-player">
      <img src={cover} alt={title} className="thumbnail-small" />
      <div className="thumbnail-title">{title}</div>
      <audio ref={audioRef} src={url} preload="auto" />
      <button onClick={togglePlay}>{isPlaying ? "⏹️ Stop" : "▶️ Play"}</button>
    </div>
  );
}


// -----------------------------
// 🎵 Discos con sus pistas
// -----------------------------
const albums = [
  {
    id: 1,
    title: "Big Mamarracho",
    cover:
      "https://www.malditosanimales.com.ar/Discografia/tapas/bigmamarracho.jpg",
    tracks: [
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/bigmamarracho/01 - Antes de Nacer.mp3",
        title: "01 - Antes de nacer",
        tags: ["Acústico Filosofal"],
        filename: "01 - Antes de Nacer.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/bigmamarracho/02 - ElTiempo Da La Razon.mp3",
        title: "02 - El tiempo da la razón",
        tags: ["Electropop acusatorio"],
        filename: "02 - ElTiempo Da La Razon.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/bigmamarracho/03 - Hay algo que no está bien.mp3",
        title: "03 - Hay algo que no está bien",
        tags: ["Distorsión Mental"],
        filename: "03 - Hay algo que no está bien.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/bigmamarracho/04 - This is a mamarracho.mp3",
        title: "04 - This is a mamarracho",
        tags: ["Guacarock"],
        filename: "04 - This is a mamarracho.mp3",
        videoUrl: "https://www.youtube.com/watch?v=tOfQ0V6qhZw",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/bigmamarracho/05 - Podria Haberte Ido A Buscar.mp3",
        title: "05 - Podría haberte ido a buscar",
        tags: ["Weird Country"],
        filename: "05 - Podria Haberte Ido A Buscar.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/bigmamarracho/06 - EstaTodo Mal.mp3",
        title: "06 - Está todo mal",
        tags: ["Simil Radio"],
        filename: "06 - EstaTodo Mal.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/bigmamarracho/07 - Soy Una Nube De Atomos.mp3",
        title: "07 - Soy una nube de átomos",
        tags: ["Freak Folk"],
        filename: "07 - Soy Una Nube De Atomos.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/bigmamarracho/08 - Pena en alma.mp3",
        title: "08 - Pena en alma",
        tags: ["Urban Rock"],
        filename: "08 - Pena en alma.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/bigmamarracho/09 - Se termina la esperanza.mp3",
        title: "09 - Se termina la esperanza",
        tags: ["Low Res Techno"],
        filename: "09 - Se termina la esperanza.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/bigmamarracho/10 - Mate con azúcar.mp3",
        title: "10 - Mate con azúcar",
        tags: ["Useless Song"],
        filename: "10 - Mate con azúcar.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/bigmamarracho/11 - Fade out de un amor que se fue.mp3",
        title: "11 - Fade out de un amor que se fue",
        tags: ["Not Live'N'Roll"],
        filename: "11 - Fade out de un amor que se fue.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/bigmamarracho/12 - No tiene carne.mp3",
        title: "12 - No tiene carne",
        tags: ["Cumbia Espectral"],
        filename: "12 - No tiene carne.mp3",
      },
    ],
  },
  {
    id: 2,
    title: "Pesadillear",
    cover:
      "https://www.malditosanimales.com.ar/Discografia/tapas/pesadillear.jpg",
    tracks: [
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/pesadillear/01 - Alfombra - Botavema 3 - Lounge version.mp3",
        title: "01 - Alfombra",
        tags: ["Revival lounge"],
        filename: "01 - Alfombra - Botavema 3 - Lounge version.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/pesadillear/02 - Calamidad.mp3",
        title: "02 - Calamidad",
        tags: ["Electric sorrow"],
        filename: "02 - Calamidad.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/pesadillear/03 - Canción inútil (para calmar el dolor).mp3",
        title: "03 - Canción inútil (para calmar el dolor)",
        tags: ["Acoustic pain"],
        filename: "03 - Canción inútil (para calmar el dolor).mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/pesadillear04 - La chica  de la mancha de café.mp3",
        title: "04 - La chica de la mancha de café",
        tags: ["Dope pop rock"],
        filename: "04 - La chica de la mancha de café.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/pesadillear/05 - La realidad.mp3",
        title: "05 - La realidad",
        tags: ["Explicit tears"],
        filename: "05 - La realidad.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/pesadillear/06 - Me dibuja el camino la luna.mp3",
        title: "06 - Me dibuja el camino la luna",
        tags: ["Default hit"],
        filename: "06 - Me dibuja el camino la luna.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/pesadillear/07 - Noches ciegas.mp3",
        title: "07 - Noches ciegas",
        tags: ["Female white noise"],
        filename: "07 - Noches ciegas.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/pesadillear/08 - Pesadillear.mp3",
        title: "08 - Pesadillear",
        tags: ["Final grey dead"],
        filename: "08 - Pesadillear.mp3",
      },
    ],
  },
  {
    id: 3,
    title: "Tres",
    cover: "https://www.malditosanimales.com.ar/Discografia/tapas/tres.jpg",
    tracks: [
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/tres/01 - Caer en el vacio de la ignominia.mp3",
        title: "01 - Caer en el vacío de la ignominia",
        tags: ["Crisis song"],
        filename: "01 - Caer en el vacío de la ignominia.mp3",
        videoUrl: "https://youtu.be/q3ftj5egX_k",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/tres/02 - Cosas que le pasan a la gente.mp3",
        title: "02 - Cosas que le pasan a la gente",
        tags: ["Evil of many"],
        filename: "02 - Cosas que le pasan a la gente.mp3",
        videoUrl: "https://youtu.be/yqln1rlIXqk",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/tres/03 - Cómo pasa el tiempo.mp3",
        title: "03 - Cómo pasa el tiempo",
        tags: ["Pass by the time"],
        filename: "03 - Cómo pasa el tiempo.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/tres/04 - Dónde está la realidad.mp3",
        title: "04 - Dónde está la realidad",
        tags: ["Unreal song"],
        filename: "04 - Dónde está la realidad.mp3",
        videoUrl: "https://youtu.be/W8bT5dB5wV8",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/tres/05 - Fuera de mí.mp3",
        title: "05 - Fuera de mí",
        tags: ["External beat"],
        filename: "05 - Fuera de mí.mp3",
        videoUrl: "https://youtu.be/7BfqOtU3-uA",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/tres/06 - Hola Que tal.mp3",
        title: "06 - Hola Que tal",
        tags: ["Acoustic greeting"],
        filename: "06 - Hola Que tal.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/tres/07 - Oslo.mp3",
        title: "07 - Oslo",
        tags: ["Oslo way of life"],
        filename: "07 - Oslo.mp3",
        videoUrl: "https://youtu.be/Uw8bYGKZ9RQ",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/tres/08 - Todo es natural.mp3",
        title: "08 - Todo es natural",
        tags: ["Ecological and roll"],
        filename: "08 - Todo es natural.mp3",
        videoUrl: "https://youtu.be/wijzdsY8MIg",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/tres/09 - Todo se cae.mp3",
        title: "09 - Todo se cae",
        tags: ["Falling down music"],
        filename: "09 - Todo se cae.mp3",
        videoUrl: "https://youtu.be/4ochJshFMxE",
      },
    ],
  },
  {
    id: 4,
    title: "Malditos Animales y La Pesada",
    cover: "https://www.malditosanimales.com.ar/Discografia/tapas/maylp.jpg",
    tracks: [
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/maylp/Anoche soñé con vos- MAyLP.mp3",
        title: "Anoche soñé con vos",
        tags: ["Vinilo Onírico"],
        filename: "Anoche soñé con vos- MAyLP.mp3"
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/maylp/Blues de Sábado Sin Ganas - MAyLP.mp3",
        title: "Blues de Sábado Sin Ganas",
        tags: ["Psicoblues"],
        filename: "Blues de Sábado Sin Ganas - MAyLP.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/maylp/Diez horas por segundo  - MAYLP.mp3",
        title: "Diez horas por segundo ",
        tags: ["Ansiedad rock"],
        filename: "Diez horas por segundo  - MAYLP.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/maylp/La carne se está cociendo - MAYLP.mp3",
        title: "La carne se está cociendo",
        tags: ["Rock a punto"],
        filename: "La carne se está cociendo - MAYLP.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/maylp/Mi abrazo tiene tu forma - MAYLP.mp3",
        title: "Mi abrazo tiene tu forma",
        tags: ["Folkrockdistort"],
        filename: "Mi abrazo tiene tu forma - MAYLP.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/maylp/No viene nada - MAYLP.mp3",
        title: "No viene nada",
        tags: ["Angustia existencial rock"],
        filename: "No viene nada - MAYLP.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/maylp/Sueños Raros - MAYLP.mp3",
        title: "Sueños Raros",
        tags: ["No sabés lo que soñé rock"],
        filename: "Sueños Raros - MAYLP.mp3",
      },
    ],
  },
  {
    id: 5,
    title: "La materia no se ordena como espero",
    cover: "https://www.malditosanimales.com.ar/Discografia/tapas/lmnsoce.jpg",
    tracks: [
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/lmnsoce/01_Situación de caos.mp3",
        title: "01_Situación de caos",
        tags: ["Electronic naif No wave"],
        filename: "01_Situación de caos.mp3"
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/lmnsoce/02_La chica de la mancha de café.mp3",
        title: "02_La chica de la mancha de café",
        tags: ["Desperate naif"],
        filename: "02_La chica de la mancha de café.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/lmnsoce/03_No tengo corazón.mp3",
        title: "03_No tengo corazón",
        tags: ["Acoustic naif"],
        filename: "03_No tengo corazón.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/lmnsoce/04_¿Dónde queda la felicidad_.mp3",
        title: "04_¿Dónde queda la felicidad?",
        tags: ["Naif no wave"],
        filename: "04_¿Dónde queda la felicidad_.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/lmnsoce/05_Muy de vez en cuando.mp3",
        title: "05_Muy de vez en cuando",
        tags: ["Electronic naif tango"],
        filename: "Mi abrazo tiene tu forma - MAYLP.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/lmnsoce/06_La materia no se ordena como espero.mp3",
        title: "06_La materia no se ordena como espero",
        tags: ["Electronic no wave"],
        filename: "06_La materia no se ordena como espero.mp3",
      }
    ],
  },
];

// -----------------------------
// 🖼️ Extras (link + audios WAV)
// -----------------------------
const extras = [
  {
    id: "ext-link",
    title: "99 No Gardeles",
    cover:
      "https://www.malditosanimales.com.ar/Discografia/tapas/Gardel.png",
    type: "link",
    url: "https://opensea.io/collection/99nogardeles",
  },
  {
    id: "ext-audio-1",
    title: "Sobre 99 NG (Audio 1)",
    cover:
      "https://www.malditosanimales.com.ar/Discografia/tapas/Gardel.png",
    type: "audio",
    url: "https://www.malditosanimales.com.ar/Discografia/mp3/podcasts/99NoGardeles01.wav",
  },
  {
    id: "ext-audio-2",
    title: "Sobre 99 NG (Audio 2)",
    cover:
      "https://www.malditosanimales.com.ar/Discografia/tapas/Gardel.png",
    type: "audio",
    url: "https://www.malditosanimales.com.ar/Discografia/mp3/podcasts/99NoGardeles02.wav",
  },
  {
    id: "ext-audio-3",
    title: "Sobre 99 NG (Audio 3)",
    cover:
      "https://www.malditosanimales.com.ar/Discografia/tapas/Gardel.png",
    type: "audio",
    url: "https://www.malditosanimales.com.ar/Discografia/mp3/podcasts/99NoGardeles03.wav",
  },
  {
    id: "ext-link-diario",
    title: "El diario de nadie",
    cover:
      "https://www.malditosanimales.com.ar/Discografia/tapas/diario.png",
    type: "link",
    url: "https://www.malditosanimales.com.ar/diariodenadie/",
  },
  {
    id: "ext-link-maq",
    title: "Máquina de escribir",
    cover:
      "https://www.malditosanimales.com.ar/Discografia/tapas/maquina.png",
    type: "link",
    url: "https://www.malditosanimales.com.ar/maquina/",
  },
  {
    id: "ext-link-poetica",
    title: "Poética Artificial",
    cover:
      "https://www.malditosanimales.com.ar/Discografia/tapas/poeticaartificial.png",
    type: "pdf",
    url: "https://www.malditosanimales.com.ar/maquina/poeticaartificial.pdf",
  },
];

// -----------------------------
// 🎨 Colores del reproductor
// -----------------------------
const colors = {
  tagsBackground: "#444",
  tagsText: "#ccc",
  tagsBackgroundHoverActive: "#666",
  tagsTextHoverActive: "#eee",
  searchBackground: "#222",
  searchText: "#ccc",
  searchPlaceHolder: "#555",
  playerBackground: "#111",
  titleColor: "#ccc",
  timeColor: "#ccc",
  progressSlider: "#666",
  progressUsed: "#ccc",
  progressLeft: "#333",
  bufferLoaded: "#444",
  volumeSlider: "#666",
  volumeUsed: "#ccc",
  volumeLeft: "#333",
  playlistBackground: "#111",
  playlistText: "#555",
  playlistBackgroundHoverActive: "#222",
  playlistTextHoverActive: "#ccc",
};

// ====================================================================
// 📱🎧 Componente principal
// ====================================================================
function App() {
  // 🟢 Álbum inicial: "Tres"
  const [currentAlbum, setCurrentAlbum] = useState(
    albums.findIndex((alb) => alb.id === 5)
  );
  const [filterTag, setFilterTag] = useState(null);
  const [isDownloadsVisible, setDownloadsVisible] = useState(false);
  const [isFullScreen, setFullScreen] = useState(false);

  // 🎙️ Reproductor para audios extra (WAV)
  const extraAudioRef = useRef(null);

  const playExtraAudio = (url) => {
    if (!extraAudioRef.current) {
      extraAudioRef.current = new Audio(url);
    }
    const audio = extraAudioRef.current;

    // Si ya está sonando
    if (!audio.paused) {
      audio.pause();
    }
    audio.src = url;
    audio.play();
  };

  // 🔌 Limpieza al desmontar
  useEffect(() => {
    return () => {
      if (extraAudioRef.current) {
        extraAudioRef.current.pause();
      }
    };
  }, []);

  // ------------------------------------------------
  // 📀 Datos del álbum actual
  // ------------------------------------------------
  const album = albums[currentAlbum];
  const tracksToShow = filterTag
    ? album.tracks.filter((track) => track.tags.includes(filterTag))
    : album.tracks;

  const toggleDownloads = () => setDownloadsVisible(!isDownloadsVisible);
  const toggleFullScreen = () => setFullScreen(!isFullScreen);

  // -----------------------------
  // 🖼️ Renderizado
  // -----------------------------
  return (
    <div className="App">
      <header className="head">
        <h1>Malditos Animales</h1>
        <h3>Música - Videos - NFTs - Todo IA</h3>
      </header>

      {/* ================= Desktop ================= */}
      <BrowserView className="flipbook">
        <div className="player-container">
          <div className="player-area">
            <h2 className="album-title">Album: {album.title}</h2>

            {album.videoList && (
              <a
                href={album.videoList}
                target="_blank"
                rel="noopener noreferrer"
                className="album-video-link">
                Ver lista de reproducción de videos
              </a>
            )}

            <Player
              key={album.id}
              trackList={tracksToShow}
              includeTags={false}
              customColorScheme={colors}
              includeSearch={false}
            />

            {/* Links a videos de cada tema */}
            <ul className="track-video-links">
              {tracksToShow.map((track, idx) =>
                track.videoUrl ? (
                  <li key={idx}>
                    <a
                      href={track.videoUrl}
                      target="_blank"
                      rel="noopener noreferrer">
                      🎬 Ver video de: {track.title}
                    </a>
                  </li>
                ) : null
              )}
            </ul>

            {/* Descargas */}
            <button onClick={toggleDownloads} className="download-toggle">
              {isDownloadsVisible ? "Cerrar Descargas" : "Abrir Descargas"}
            </button>
            {isDownloadsVisible && (
              <footer className="downloads-footer">
                <h4>Descargar temas:</h4>
                <ul>
                  {tracksToShow.map((track, idx) => (
                    <li key={idx}>
                      <a href={track.url} download={track.filename}>
                        {track.title}
                      </a>
                    </li>
                  ))}
                </ul>
              </footer>
            )}
          </div>

          {/* Portada */}
          <div className="cover-area-right">
            <img
              alt={`Tapa de ${album.title}`}
              src={album.cover}
              onClick={toggleFullScreen}
              className="cover-img-right"
            />
            {isFullScreen && (
              <div className="fullscreen-overlay" onClick={toggleFullScreen}>
                <img
                  src={album.cover}
                  alt={`Tapa de ${album.title} en pantalla completa`}
                  className="fullscreen-img"
                />
              </div>
            )}
          </div>
        </div>

         {/* Thumbnails Desktop */}
      <div className="album-nav-thumbnails-bottom">
        {albums.map((alb, idx) => (
          <div
            key={alb.id}
            className={`thumbnail-wrapper ${idx === currentAlbum ? "selected" : ""}`}
            onClick={() => {
              setCurrentAlbum(idx);
              setFilterTag(null);
            }}>
            <img src={alb.cover} alt={alb.title} className="thumbnail-small" />
            <div className="thumbnail-title">{alb.title}</div>
          </div>
        ))}

        {/* Extras */}
        {extras.map((item) => (
  <div key={item.id} className="thumbnail-wrapper extra">
    {item.type === "link" && (
      <div
        onClick={() => window.open(item.url, "_blank", "noopener,noreferrer")}
      >
        <img src={item.cover} alt={item.title} className="thumbnail-small" />
        <div className="thumbnail-title">{item.title}</div>
      </div>
    )}

    {item.type === "audio" && (
          <ExtraAudioPlayer title={item.title} url={item.url} cover={item.cover} />
        )}

        {item.type === "pdf" && (
          <a
            href={item.url}
            download
            className="pdf-download"
            rel="noopener noreferrer"
            title="Descargar PDF"
          >
            <img src={item.cover} alt={item.title} className="thumbnail-small" />
            <div className="thumbnail-title">📄 {item.title}</div>
          </a>
        )}
      </div>
    ))}

      </div>
      </BrowserView>

      {/* ================= Mobile ================= */}
      <MobileView>
        <div className="mobile-container">
          <h2 className="album-title-mobile">{album.title}</h2>

          {album.videoList && (
            <a
              href={album.videoList}
              target="_blank"
              rel="noopener noreferrer"
              className="album-video-link-mobile">
              🎥 Ver lista de reproducción de videos del álbum
            </a>
          )}

          {/* Portada mobile */}
          <div
            className="cover-container-mobile"
            style={{
              paddingTop: "env(safe-area-inset-top)",
              paddingBottom: "env(safe-area-inset-bottom)",
            }}>
            <img
              alt={`Tapa de ${album.title}`}
              src={album.cover}
              onClick={toggleFullScreen}
              className="cover-img-mobile"
              style={{ width: "100%", height: "auto", objectFit: "cover" }}
            />
          </div>
          {isFullScreen && (
            <div className="fullscreen-overlay" onClick={toggleFullScreen}>
              <img
                src={album.cover}
                alt={`Tapa de ${album.title} en pantalla completa`}
                className="fullscreen-img"
              />
            </div>
          )}

          {/* Reproductor mobile */}
          <div className="player-mobile">
            <Player
              trackList={tracksToShow}
              includeTags={false}
              customColorScheme={colors}
              includeSearch={false}
            />
          </div>

          {/* Dropdown videos mobile */}
          {tracksToShow.some((track) => track.videoUrl) && (
            <div className="track-video-dropdown-mobile">
              <label htmlFor="videoSelectMobile">🎬 Ver video de:</label>
              <select
                id="videoSelectMobile"
                onChange={(e) => {
                  const url = e.target.value;
                  if (url) window.open(url, "_blank", "noopener,noreferrer");
                }}
                className="video-select-mobile">
                <option value="">Selecciona un tema...</option>
                {tracksToShow.filter((track) => track.videoUrl).map((track, idx) => (
                  <option key={idx} value={track.videoUrl}>
                    {track.title}
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* Descargas mobile */}
          <button onClick={toggleDownloads} className="download-toggle-mobile">
            {isDownloadsVisible ? "Cerrar Descargas" : "Abrir Descargas"}
          </button>
          {isDownloadsVisible && (
            <footer className="downloads-footer-mobile">
              <h4>Descargar temas:</h4>
              <ul>
                {tracksToShow.map((track, idx) => (
                  <li key={idx}>
                    <a href={track.url} download={track.filename}>
                      {track.title}
                    </a>
                  </li>
                ))}
              </ul>
            </footer>
          )}

          {/* Thumbnails mobile */}
          <div className="album-nav-thumbnails-mobile">
            {albums.map((alb, idx) => (
              <div
                key={alb.id}
                className={`thumbnail-wrapper-mobile ${idx === currentAlbum ? "selected" : ""}`}
                onClick={() => {
                  setCurrentAlbum(idx);
                  setFilterTag(null);
                }}>
                <img
                  src={alb.cover}
                  alt={alb.title}
                  className="thumbnail-small-mobile"
                />
                <div className="thumbnail-title-mobile">{alb.title}</div>
              </div>
            ))}

            {/* Extras mobile */}
            {extras.map((item) => (
              <div key={item.id} className="thumbnail-wrapper-mobile extra">
                {item.type === "link" && (
                  <div
                    onClick={() => window.open(item.url, "_blank", "noopener,noreferrer")}
                  >
                    <img src={item.cover} alt={item.title} className="thumbnail-small-mobile" />
                    <div className="thumbnail-title-mobile">{item.title}</div>
                  </div>
                )}

                {item.type === "audio" && (
                  <div onClick={() => playExtraAudio(item.url)}>
                    <img src={item.cover} alt={item.title} className="thumbnail-small-mobile" />
                    <div className="thumbnail-title-mobile">{item.title}</div>
                  </div>
                )}

                {item.type === "pdf" && (
                  <a
                    href={item.url}
                    download
                    className="pdf-download-mobile"
                    rel="noopener noreferrer"
                    title="Descargar PDF"
                  >
                    <img src={item.cover} alt={item.title} className="thumbnail-small-mobile" />
                    <div className="thumbnail-title-mobile">📄 {item.title}</div>
                  </a>
                )}
              </div>
            ))}

          </div>
        </div>
      </MobileView>
    </div>
  );
}

export default App;
